import Head from 'next/head'
import UpcomingAuctions from '../../components/upcoming-auctions'
import SellingInfo from '../../containers/sell/selling-info'
import CTACards from '../../containers/sell/cta-cards'
import SellHero from '../../containers/sell/hero'
import Features from '../../components/features'
import Banner from '../../components/banner'
import SellingOptions from '../../containers/sell/selling-options'

export default function Sell() {
  return (
    <>
      <Head>
        <title>The Safest Way To Sell A Car Online | privauto</title>
        <meta
          name='description'
          content='DriversExchange.com is the best website to sell your car online, get the most money for your used car, and sell it safely and privately. Value your car now!'
        />
      </Head>

      <SellHero />

      <div className='container'>
        <section className='sellingInfoSection'>
          <SellingOptions />
        </section>

        <section className='sellingInfoSection'>
          <SellingInfo />
        </section>

        <section className='features'>
          <Features />
        </section>

        <section className='ctaSection'>
          <CTACards />
        </section>
      </div>

      <section className='auction'>
        <UpcomingAuctions />
      </section>

      <section className='banner'>
        <Banner />
      </section>

      <style jsx>{`
        .container {
          max-width: 193rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .sellingInfoSection {
          max-width: 151rem;
          width: 100%;
          margin: 4.6rem auto 8rem;
        }

        .features {
          max-width: 164.8rem;
          margin: 0 auto;
        }

        .ctaSection {
          margin: 10.7rem 0 10rem;
        }

        .auction {
          margin: 0 0 8rem;
        }

        .banner {
          padding: 0 4rem;
        }

        @media (max-width: 1024px) {
          .container {
            max-width: 100%;
            padding: 0 1.1rem 2rem;
          }

          .sellingInfoSection {
            margin: 1.3rem auto 4rem;
          }

          .ctaSection {
            margin: 3.7rem 0 4.9rem;
          }

          .auction {
            margin: 0 0 2rem;
          }

          .banner {
            padding: 0 1.1rem;
          }
        }
      `}</style>
    </>
  )
}

Sell.getInitialProps = async () => ({
  namespacesRequired: ['common'],
})
